window.EM = window.EM || {};
window.EM.booking = window.EM.booking || {};

(function (ns) {
  var cfg = ns.config;
  var st = ns.state;
  var utils = ns.utils;
  var data = ns.data;

  var $window, $document, footerHeight, $bookings, $loadingCopy, $bookingCopy, $eventCopy, $slotCopy;
  var _spinner = null;
  var _domReady = false;

  function ensureDom() {
    if (_domReady) return;
    _domReady = true;
    $window = $(window);
    $document = $(document);
    footerHeight = $(".footer").height() || 0;
    $bookings = $(".booking-dates");
    $loadingCopy = $(".booking-loading").clone();
    $bookingCopy = $(".booking-container").clone().removeClass("booking-container").show();
    $eventCopy = $bookingCopy.find(".booking-event").clone();
    $bookingCopy.find(".booking-event").remove();
    $slotCopy = $eventCopy.find(".booking-slot").first().clone();
  }

  function addSpinner(opt) {
    ensureDom();
    if (_spinner !== null) {
      if ($("body")[0].contains(_spinner.el) === true) {
        return;
      } else {
        _spinner = null;
      }
    }

    var $dates = $(".booking-dates");
    opt = $.extend(true, {}, { clear: true }, opt);
    if (opt.clear) {
      st.setAutoScroll(0);
      $dates.empty();
    }
    $dates.append($loadingCopy.clone());

    var spin_opts = $.extend(true, {}, DEFAULT_SPIN_OPTS);
    _spinner = new Spinner(spin_opts).spin($(".booking-loading span")[0]);
  }

  function stopSpinner() {
    if (_spinner !== null) {
      _spinner.stop();
      _spinner = null;
    }
  }

  function isWindowFull() {
    if (window.innerHeight >= $document.height() - footerHeight) {
      return false;
    }
    return true;
  }

  function showCalendar(opt) {
    utils.hideAlert();
    $(".booking-form").hide();
    $(".booking-calendar").show();
    updateCalendar(opt);
  }

  function updateCalendar(opt) {
    ensureDom();
    var state = st.get();
    opt = $.extend(true, { clear: false, next: null, force: false, updateDate: true }, opt);

    if (st.isLoading() && opt.force === false) {
      return st.getLastCalendarPromise().promise();
    }

    st.setLoading(true);
    var updateCalendarPromise = $.Deferred();
    st.setLastCalendarPromise(updateCalendarPromise);

    if (opt.clear) {
      st.setAutoScroll(0);
      $bookings.empty();
    }

    addSpinner(opt);

    if (opt.useCache) {
      state.useCache = true;
    }

    var lastDateFetched = st.getLastDateFetched();
    if (opt.next !== null) {
      if (!lastDateFetched) {
        lastDateFetched = moment.tz(state.start, "YYYYMMDD", cfg.VENUE_TZ).add(cfg.DATES_PER_FETCH, "days");
      } else {
        lastDateFetched.add(1, "days");
      }
      state.start = lastDateFetched.format("YYYYMMDD");
      lastDateFetched.add(opt.next, "days");
      state.end = lastDateFetched.format("YYYYMMDD");
    } else {
      lastDateFetched = moment.tz(state.start, "YYYYMMDD", cfg.VENUE_TZ).add(cfg.DATES_PER_FETCH, "days");
      state.end = lastDateFetched.format("YYYYMMDD");
    }
    st.setLastDateFetched(lastDateFetched);

    if (state.venue !== null || state.event !== null || state.date !== cfg.START_SEARCH_DATE.format("YYYYMMDD")) {
      $(".booking-calendar").addClass("has-filters");
    } else {
      $(".booking-calendar").removeClass("has-filters");
    }

    ns.filters.updateAllFilters({ updateDate: opt.updateDate });

    data.getBookings(state)
      .done(function (dates) {
        $bookings.find(".booking-loading").remove();

        var startDate = moment(state.start);
        var endDate = moment(state.end);
        var dateKeys = [];
        while (startDate.isSameOrBefore(endDate, "day")) {
          dateKeys.push(startDate.format("YYYYMMDD"));
          startDate.add(1, "days");
        }
        if (cfg.isLocationEvent) {
          dateKeys = Object.keys(dates);
        }

        var freeSlots = 0;
        var bookingsCount = 0;
        $.each(dateKeys, function (index, date) {
          var events = dates[date] || [];
          var $booking = $bookingCopy.clone();
          var $events = $booking.find(".booking-events");
          var $venue = $booking.find(".booking-venue");
          var $venueClone = $venue.clone();
          var slotDate = moment(date, "YYYYMMDD");
          var lastVenue = -1;
          var eventSlots = 0;
          var dayFreeSlots = 0;

          $booking.find(".booking-date").find("span").text(utils.formatDateAsLong(date));

          if (events.length === 0) {
            $booking.find(".booking-date-container").addClass("sold-out");
            $booking.find(".sold-out-message").text("Closed");
            $booking.find(".booking-venue").hide();
            if (!cfg.isLoungeHome && !cfg.isCamp) {
              $bookings.append($booking);
            }
            return;
          }

          if (index === 1 && $bookings.children().length === 1 && !cfg.isLocationEvent) {
            $bookings.append('<div class="more-dates"><hr/><h3>More Dates</h3></div>');
          }

          $.each(events, function (eventIndex, event) {
            var $event = $eventCopy.clone();
            var $slots = $event.find(".booking-slots");
            var room = data.getRoomByEventId(event.venue.id, event.reservation.id);

            $event.attr("data-date", date);
            $event.attr("data-venue", event.venue.id);
            $event.attr("data-event", event.reservation.id);

            if (lastVenue != event.venue.id) {
              $venue.find("span").eq(0).html(event.venue.name);
              if (event.venue.notes) {
                $venue.find("small").eq(0).html(event.venue.notes);
              }
              if (lastVenue != -1) {
                $events.append('<hr class="mt-0"/>');
                $events.append($venue);
              }
              $venue = $venueClone.clone();
              lastVenue = event.venue.id;
            }

            $slots.empty();
            $event.find(".booking-name").html(event.reservation.name + event.reservation.icons);

            var $bookingInfo = $event.find(".booking-info");
            if (event.room.info) {
              $bookingInfo.show().find(".booking-info-text").html(event.room.info);
            }
            if (room && room.moreInfo) {
              $bookingInfo
                .find(".more-info")
                .hide()
                .tooltip({
                  delay: { show: 300, hide: 300 },
                  html: true,
                  trigger: "click",
                  template: utils.TOOLTIP_TEMPLATE,
                  title: room.moreInfo,
                })
                .on("show.bs.tooltip", function (e) {
                  var $backdrop = $('<div class="tooltip-backdrop"></div>');
                  $backdrop.data("target", e.currentTarget);
                  $("body").append($backdrop);
                  $backdrop.on("click", function () {
                    var $target = $($(this).data().target);
                    $target.tooltip("hide");
                  });
                })
                .on("hidden.bs.tooltip", function () {
                  $(".tooltip-backdrop").remove();
                });
            } else {
              $bookingInfo.find(".more-info").hide();
            }
            $event.find(".booking-date > span").text(slotDate.format("MMMM D, YYYY"));

            var hide = false;
            if (state.venue !== null && state.venue !== event.venue.id) {
              hide = true;
            }

            if (typeof state.events !== "undefined") {
              var found = false;
              state.events.forEach(function (eventId) {
                if ($.inArray(eventId, event.room.eventIds) > -1) {
                  found = true;
                }
              });
              hide = found === false;
            } else if (state.event !== null && $.inArray(state.event, event.room.eventIds) === -1) {
              hide = true;
            }

            if (hide) {
              $event.hide();
            } else {
              var room = data.getRoomByEventId(event.venue.id, event.reservation.id);
              if (room === null) {
                if (typeof Sentry !== "undefined") {
                  Sentry.captureException(new Error("getBookings: room is null"), {
                    extra: { state: state, event: event },
                  });
                }
                return;
              }
              if (room.openTableId) {
                var $slot = $slotCopy.clone();
                var slotTime = moment.tz(date + " " + cfg.NOW.format("HH:mm"), "YYYYMMDD HH:mm", cfg.VENUE_TZ);
                $slot.attr("data-event", event.reservation.id);
                $slot.attr("data-open-table", room.openTableId);
                $slot.find(".booking-time").text("Find a Table");
                if (slotTime.isSame(cfg.NOW, "day")) {
                  $slot.attr("data-time", slotTime.add(75, "minutes").startOf("hour").format("HH:mm"));
                } else {
                  $slot.attr("data-time", "17:00");
                }
                $slot.addClass("slot-open-table");
                $slots.append($slot);
                $events.append($event);
                return;
              }
              var eventSlotCount = 0;
              $.each(event.times, function (timeIndex, time) {
                $.each(time.slots, function (slotIndex, slot) {
                  var $slot = $slotCopy.clone();

                  if (slot.eventId) {
                    $slot.attr("data-event", slot.eventId);
                  }

                  var slotTime = moment.tz(date + " " + slot.time, "YYYYMMDD HH:mm", cfg.VENUE_TZ);
                  if (parseInt(slot.time.replace(":", "")) < 600) {
                    slotTime.add(1, "day");
                  }
                  if (slotTime.isBefore(cfg.NOW)) {
                    slot.free = 0;
                  }

                  var minimumPlayers = event.reservation.slot.minGroupSize;
                  var privateRoomSize = event.reservation.slot.maxGroupSize > 6 ? 2 : 1;
                  var privateRoomPlayers = room.privateRoomPlayers ? room.privateRoomPlayers : event.reservation.slot.maxGroupSize - privateRoomSize;

                  if (slot.free <= event.reservation.slot.maxGroupSize - privateRoomPlayers) {
                    $slot.addClass("unavailable");
                  } else if (slot.free < minimumPlayers) {
                    $slot.addClass("unavailable");
                  } else {
                    $slot.removeClass("unavailable");
                    $slot.attr("data-time", slot.time);
                    dayFreeSlots += 1;
                    freeSlots += 1;
                  }

                  if ($slot.hasClass("unavailable") && slotTime.hour() < 17 && [460, 480, 493].includes(event.venue.id) && [0, 6].includes(slotTime.day()) && date >= 20241125 && date <= 20241220) {
                    $slot.hide();
                  }

                  if (slot.eventId) {
                    var slotPrice = event.eventPrices.find(function (ep) {
                      return ep.eventId === slot.eventId;
                    });
                    var price = (slotPrice.taxIncluded ? slotPrice.total : slotPrice.price) || 0;
                    if (slotPrice.discounted) {
                      $slot.addClass("discounted");
                    }
                    if (slotPrice.price) {
                      $slot.find(".booking-free").text("$" + price);
                    } else {
                      $slot.find(".booking-free").text(slot.free);
                      $slot.find(".fa-user").removeClass("fa-user").addClass("fa-users");
                    }
                  } else if (event.prices.price) {
                    var price = (event.prices.taxIncluded ? event.prices.total : event.prices.price) || 0;
                    $slot.find(".booking-free").text("$" + price);
                  } else {
                    $slot.find(".fa-user").css({ opacity: 0 });
                  }
                  if (cfg.EVENT_NAME === "oktoberfest") {
                    $slot.find(".booking-time").text("PURCHASE");
                  } else {
                    $slot.find(".booking-time").text(utils.formatTime(slot.time));
                  }
                  if (room && room.hidePlayers === true) {
                    $slot.find(".fa-user").remove();
                  }

                  $slots.append($slot);
                  eventSlots++;
                  eventSlotCount++;
                });
              });
              if (eventSlotCount) {
                $events.append($event);
              }
            }
          });

          if (eventSlots > 0 && dayFreeSlots === 0) {
            $booking.find(".booking-date-container").addClass("sold-out");
            if (cfg.site === "regina") {
              $booking
                .find(".sold-out-message")
                .replaceWith(
                  '<div class=""><p class="mt-4 text-primary">Limited availability</p><p class="text-sm text-primary-alt">Please email <a href="mailto:gatekeeper@escapemanor.com">gatekeeper@escapemanor.com</a> to make a reservation.</p></div>',
                );
            }
            if (cfg.isLoungeHome) {
              return;
            }
          }
          if (cfg.isLoungeHome && bookingsCount > 0) {
            return;
          }
          $bookings.append($booking);
          bookingsCount += 1;
        });

        var currentLastDate = st.getLastDateFetched();
        if (cfg.SCROLL_ENABLED && ((currentLastDate.isBefore(cfg.SIX_MONTHS) && freeSlots === 0) || (currentLastDate.isBefore(cfg.SIX_MONTHS) && isWindowFull() === false))) {
          return updateCalendar({ next: cfg.isLoungeHome ? cfg.DATES_PER_FETCH : 14, clear: false, force: true, updateDate: false }).then(function () {
            updateCalendarPromise.resolve();
          });
        } else {
          if ($(".booking-dates > div").length === 0) {
            $(".booking-dates").empty();
            $(".noslots-error").clone().show().appendTo(".booking-dates");
          }
          st.setLoading(false);
          return updateCalendarPromise.resolve();
        }
      })
      .fail(function () {
        $(".booking-dates").empty();
        $(".connection-error").clone().show().appendTo(".booking-dates");
        st.setLoading(false);
        return updateCalendarPromise.reject();
      });

    return updateCalendarPromise.promise();
  }

  function loadOnScroll() {
    if (window.scrollY + window.innerHeight >= $document.height() - footerHeight) {
      if (st.isLoading() || st.getAutoScroll()) {
        st.incrementAutoScroll();
        return;
      }

      var allDates = st.getAllDates();
      var state = st.get();
      if (!st.isLoading() && allDates && $(".booking-calendar").is(":visible")) {
        var lastDateFetched = st.getLastDateFetched();
        if (lastDateFetched && lastDateFetched.isAfter(cfg.SIX_MONTHS)) {
          stopSpinner();
          return;
        }
        st.incrementAutoScroll();

        if (DEVELOPMENT) {
          console.log("Auto load:: loading");
        }

        var nextDays = state.event !== null ? 14 : cfg.DATES_PER_FETCH;
        updateCalendar({ next: nextDays, clear: false, updateDate: false })
          .then(function () {
            st.decrementAutoScroll();
            if (st.getAutoScroll()) {
              st.setAutoScroll(0);
              loadOnScroll();
            }
          })
          .fail(function () {
            st.setAutoScroll(0);
          });
      }
    }
  }

  function bindScrollListener() {
    ensureDom();
    if (cfg.SCROLL_ENABLED) {
      $window.scroll(loadOnScroll);
    }
  }

  ns.calendar = {
    addSpinner: addSpinner,
    stopSpinner: stopSpinner,
    isWindowFull: isWindowFull,
    showCalendar: showCalendar,
    updateCalendar: updateCalendar,
    loadOnScroll: loadOnScroll,
    bindScrollListener: bindScrollListener,
  };
})(window.EM.booking);
